import { AxiosError } from 'axios';
import { PURGE } from 'redux-persist';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { signOut } from '~modules/auth/api/api-service/sign-out';
import { setAccessToken } from '~modules/auth/store/auth-actions';

import {
  tenantSendOtp,
  tenantVerifyOtp,
} from '~tenant-modules/auth/api/api-service/tenant-auth';
import { setTenantAccessToken } from '~tenant-modules/auth/store/tenant-auth-actions';

import { resetAuthSensitiveQueries } from '~system/query/auth-query-cache';
import { queryClient } from '~system/query/query-client';
import { setScope } from '~system/store/scope/scope-slice';
import { triggerToast } from '~system/store/toast/toast-slice';

import { ApiTenantAuthRequest, ApiTenantOtpVerifyRequest } from '~shared/types';

export const tenantVerifyOtpThunk = createAsyncThunk(
  'tenantAuth/verifyOtp',
  async (verifyOtp: ApiTenantOtpVerifyRequest, thunkAPI) => {
    try {
      const data = await tenantVerifyOtp(verifyOtp);

      thunkAPI.dispatch(setAccessToken(null));
      thunkAPI.dispatch(setTenantAccessToken(data.access_token));
      thunkAPI.dispatch(setScope('tenant'));

      queryClient.invalidateQueries({
        predicate: (query) => {
          return query.queryKey[0] !== 'invite-info';
        },
      });

      thunkAPI.dispatch(
        triggerToast({
          title: 'Авторизовано',
          message: 'Ви успішно увійшли в систему',
          type: 'success',
        }),
      );

      return data;
    } catch (error) {
      thunkAPI.dispatch(
        triggerToast({
          title: 'Помилка авторизації',
          message: (error as AxiosError<{ message: string }>).response?.data
            ?.message,
          type: 'error',
        }),
      );

      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const tenantSignInThunk = createAsyncThunk(
  'tenantAuth/signIn',
  async (signInData: ApiTenantAuthRequest, thunkAPI) => {
    try {
      const data = await tenantSendOtp(signInData);

      return data;
    } catch (error) {
      thunkAPI.dispatch(
        triggerToast({
          title: 'Помилка авторизації',
          message: (error as AxiosError<{ message: string }>).response?.data
            ?.message,
          type: 'error',
        }),
      );

      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const tenantSignOutThunk = createAsyncThunk(
  'tenantAuth/signOut',
  async (_, thunkAPI) => {
    try {
      await signOut();
    } finally {
      resetAuthSensitiveQueries();

      thunkAPI.dispatch(setAccessToken(null));
      thunkAPI.dispatch(setTenantAccessToken(null));
      thunkAPI.dispatch({ type: PURGE, key: 'tenantAuth' });
    }
  },
);
